module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"movie-count":"Featured movies","vip_badge":"VIP","svip_badge":"SVIP","annual_badge":"Annual","limited_badge":"Limited","expired_badge":"Expired","movie_count":"# Movies","latest_movie":"Latest Movie"},"ja":{"movie-count":"出演作品数","vip_badge":"VIP","svip_badge":"超VIP","annual_badge":"年間","limited_badge":"期間限定","expired_badge":"配信終了","movie_count":"出演作品数","latest_movie":"最新作"}}')
  delete Component.options._Ctor
}
